export default __webpack_public_path__ + "static/media/lspei.00e3c2d8.png";